module.exports = __webpack_public_path__ + "img/6.187a4467.gif";